import { useMutation, gql } from "@apollo/client";
import { MutationResetPasswordArgs } from "../../__generated__/types";

const RESET_PASSWORD = gql`
  mutation ResetPassword($email: String!, $password: String!) {
    resetPassword(email: $email, password: $password)
  }
`;

export const useResetPasswordMutation = () => {
  const [resetPassword, { loading, error }] = useMutation(RESET_PASSWORD, {
    onError: (error) => {
      console.error("Error resetting password:", error.message);
    },
  });

  const handleResetPassword = async (data: MutationResetPasswordArgs) => {
    const { email, password } = data;
    try {
      const result = await resetPassword({
        variables: { email, password },
      });
      return result.data?.resetPassword;
    } catch (error) {
      console.error("Error occurred during password reset.");
      return { error: "An error occurred during password reset." };
    }
  };

  return {
    handleResetPassword,
    loading,
    error,
  };
};
